import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ServerPath } from '../../../Constant';
import { _axios } from '../../../utils/axios'; 


const AddDocument = () => {
    const [show, setShow] = useState(false);
    const [DocumentName, setDocumentName] = useState('');
    const navigate = useNavigate();


    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSubmit = async (event) => {
        event.preventDefault();

        const newDocument = {
            tenant_id: "nagpur_001",
            document_name: DocumentName,
            status: 1,
        };

        try {
            const response = await _axios.post(`${ServerPath}/document/create`, newDocument);

            console.log(response.data);

            handleClose();
            navigate(0);

        } catch (error) {
            console.error(error);
        }
    };

    return (
        <>
            <button onClick={handleShow} className='btn btn-primary float-end'>Create List</button>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Create Document</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Form.Group as={Col} controlId='formGridDocumentName'>
                                <Form.Label>Document Name</Form.Label>
                                <Form.Control
                                    type='text'
                                    placeholder='Document Name'
                                    value={DocumentName}
                                    onChange={(e) => setDocumentName(e.target.value)}
                                />
                            </Form.Group>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button form='AddDocForm' variant="primary" type='submit' onClick={handleSubmit}>Submit</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default AddDocument;
